import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireDist } from "D:\\Development\\pulse-frame\\dist\\index.js";
var distExports = requireDist();
export { distExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(distExports);